import {PipelinesList} from './list';

export const PipelinesPage = () => <PipelinesList />;
